import { ChangeDetectionStrategy, Component, Input, OnChanges, signal } from '@angular/core';
import { Router } from '@angular/router';
import { GameType } from 'angular-to-phaser';
import { ApplicationService } from 'src/app/services/application.service';
import { GameDataService } from 'src/app/services/game-data.service';
import { SpotlightEvent, SpotlightImageType, SpotlightNavigationType } from '../../../dto';

@Component({
    selector: 'app-spotlight-card',
    templateUrl: './spotlight-card.component.html',
    styleUrls: ['./spotlight-card.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightCardComponent implements OnChanges {
    @Input() event: SpotlightEvent;

    imageUrl = signal<string>(null);

    constructor(private router: Router, private coreAppService: ApplicationService, private gameDataService: GameDataService) { }

    ngOnChanges(): void {
        this.imageUrl.set(null);
        if (!this.event?.Image) return;

        switch (this.event.Image.Type) {
            case SpotlightImageType.UserAvatar:
                this.coreAppService.userService.retrieveUserProfile(this.event.Image.TargetId)
                    .subscribe(profile => this.imageUrl.set(profile?.Image?.ImagePath));
                break;
            case SpotlightImageType.GameIcon:
                this.gameDataService.retrieveGameConfig(+this.event.Image.TargetId as GameType)
                    .subscribe(cfg => this.imageUrl.set(cfg?.ImagePath));
                break;
            // PumpkinSubmission has no per-upload image lookup yet - card renders text-only for this Kind.
            default:
                break;
        }
    }

    navigate(): void {
        if (!this.event?.Navigation) return;

        switch (this.event.Navigation.Type) {
            case SpotlightNavigationType.Profile:
                this.router.navigate(['/user/' + this.event.Navigation.TargetId]);
                break;
            case SpotlightNavigationType.Game:
                this.router.navigate(['/games/' + this.event.Navigation.TargetId]);
                break;
            case SpotlightNavigationType.Shop:
                this.router.navigate(['/shop/' + this.event.Navigation.TargetId]);
                break;
            // Contest/PumpkinSubmission has no dedicated destination route yet - no-op until one exists.
            default:
                break;
        }
    }
}
